import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CheckTwoFactorAuthStatusDto, SetTwoFactorAuthDto, TwoFactorAuthSettingDto, TwoFactorAuthStatusDto } from '../../contracts/dtos/two-factor-auth/models';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorAuthService {
  apiName = 'Default';
  

  checkUserStatus = (input: CheckTwoFactorAuthStatusDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TwoFactorAuthStatusDto>({
      method: 'POST',
      url: '/api/app/two-factor-auth/check-user-status',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getSetting = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, TwoFactorAuthSettingDto>({
      method: 'GET',
      url: '/api/app/two-factor-auth/setting',
    },
    { apiName: this.apiName,...config });
  

  setSetting = (input: SetTwoFactorAuthDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TwoFactorAuthSettingDto>({
      method: 'POST',
      url: '/api/app/two-factor-auth/set-setting',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
